export const GREY_BUTTON_COLOR = 'rgb(223, 223, 223)';
export const DARK_GREY_BUTTON_COLOR = 'rgb(80, 80, 80)';
export const WHITE_BUTTON_COLOR = 'rgb(255, 255, 255)';
export const RED_BUTTON_COLOR = 'rgb(224, 65, 65)';
export const LIGHT_BLACK_BUTTON_COLOR = 'rgb(39, 39, 39)';
export const BLACK_BUTTON_COLOR = 'rgb(0, 0, 0)';
export const ROYAL_BLUE_COLOR = 'rgb(90, 123, 223)';